"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportWebVitals = exports.AxiomWebVitals = void 0;
const navigation_1 = require("next/navigation");
const web_vitals_1 = require("next/web-vitals");
const webVitals_1 = require("./webVitals");
var components_1 = require("./components");
Object.defineProperty(exports, "AxiomWebVitals", { enumerable: true, get: function () { return components_1.AxiomWebVitals; } });
function useReportWebVitals(path) {
    const pathName = (0, navigation_1.usePathname)();
    (0, web_vitals_1.useReportWebVitals)((metric) => (0, webVitals_1.reportWebVitalsWithPath)(metric, path || pathName));
}
exports.useReportWebVitals = useReportWebVitals;
//# sourceMappingURL=index.js.map